<template lang="pug">
  .component-slider
    input(type='range', :min='min', :max='max', :step='step', :value='value', @change="updateStep")
</template>

<script>
  export default {
    name: 'Slider',
    data() {
      return {}
    },
    methods: {
      updateStep(evt) {
        this.$emit('input', parseInt(evt.target.value))
      }
    },
    computed: {},
    props: {
      value: {
        default: 0
      },
      min: {
        default: 0
      },
      max: {
        default: 100
      },
      step: {
        default: 1
      }
    }
  }
</script>

<style lang="sass">
  .component-slider
    input[type="range"]
      margin: auto
      -webkit-appearance: none
      position: relative
      overflow: hidden
      height: 20px
      width: 100%
      cursor: pointer
      border-radius: 0


    \::-webkit-slider-runnable-track
      background: #ddd

    \::-webkit-slider-thumb
      -webkit-appearance: none
      width: 20px
      height: 20px
      background: #fff
      box-shadow: -100vw 0 0 100vw dodgerblue
      border: 1px solid #999
      content: "culo"
</style>



// WEBPACK FOOTER //
// Slider.vue?1f79f17e